import { useEffect, useState } from 'react'
import PropTypes from 'prop-types'

const isMobile = window.innerWidth < 768
export function ImportTouchDesk({ touch, desktop, children }) {
  const [Component, setComponent] = useState(null)
  const importCallback = isMobile ? touch : desktop

  useEffect(() => {
    importCallback()?.then(componentDetails => {
      setComponent(componentDetails)
    })
  }, [importCallback])

  return children(Component ? Component.default : () => null)
}
ImportTouchDesk.propTypes = {
  touch: PropTypes.func.isRequired,
  desktop: PropTypes.func.isRequired
}
